// @ts-nocheck

/**
 * This is file is shadowed by api.ts and only exists so JS could import it to
 * refer to types without encountering runtime errors
 * @see https://github.com/microsoft/TypeScript/issues/41825
 */

import { Data } from "../gen/unixfs.js"
export const NodeType = Data.DataType
